// ACTIVE EXPERIMENT FLAGS
export const HEALTH_GOOD_DEAL_PLAN = 'web_health_good_deal_plan';
export const HEALTH_SHOW_GOOD_DEAL_PLAN = 'web_health_show_good_deal_plan';
export const HEALTH_RECOMMENDATION_CARD_UPDATE_V2 = 'web_recommendation_card_update_v2';
export const MEDICAID_MESSAGING = 'web_medicaid_messaging';
export const HEALTH_COVERAGE_REDIRECT = 'web_health_coverage_redirect';
export const HEALTH_VALUE_PROPS = 'web_health_value_props';
export const HEALTH_INCOME_NO_SKIP = 'web_health_income_no_skip';

// IN-ACTIVE EXPERIMENT FLAGS
export const HEALTH_RECOMMENDATION_CARD_UPDATE = 'web_recommendation_card_update';
export const HEALTH_REWRITE_M1 = 'web_ab_health_rewrite_m1';
export const HEALTH_REWRITE_M2 = 'web_ab_health_rewrite_m2'; // test condition vs usage, true means usage is active
export const GREEN_ONBOARDING_BUTTON = 'web_green_onboarding_button';
export const SUBSIDY_CELEBRATION_ALERT = 'web_subsidy_celebration';
export const POST_ESIGN_CROSS_SELL = 'web_post_esign_cross_sell';
export const WEB_LOGIT_REGRESSION_FORECAST = 'web_logit_regression_forecast';
